// src/components/admin/page-management/section-forms/GalleryForm.js
import React from 'react';
import ImageUploader from '../ImageUploader';
import VideoUploader from '../VideoUploader';

const GalleryForm = ({ content, updateContent, pageSlug }) => {
  const addImage = () => {
    const images = content?.images || [];
    const newImages = [
      ...images,
      {
        url: '',
        alt: '',
        caption: '',
        type: 'image', // 'image' or 'video'
        isActive: true,
        clickable: true,
        hoverEffect: 'zoom',
        onClickAction: 'modal', // 'modal', 'link', 'none'
        width: '', // New field for custom width
        height: '', // New field for custom height
        objectFit: 'cover' // 'cover', 'contain', 'fill'
      }
    ];
    updateContent('images', newImages);
  };

  const updateImage = (index, field, value) => {
    const images = [...(content?.images || [])];
    if (!images[index]) return;

    images[index] = {
      ...images[index],
      [field]: value
    };

    updateContent('images', images);
  };

  const removeImage = (index) => {
    const images = [...(content?.images || [])];
    images.splice(index, 1);
    updateContent('images', images);
  };

  // Handle gallery settings
  const updateGallerySetting = (field, value) => {
    console.log(`Updating gallery setting: ${field}`, value);
    updateContent(field, value);
  };

// Handle grid column updates specifically
const updateGridColumns = (device, value) => {
  const currentGridColumns = content?.gridColumns || {
    mobile: 1,
    tablet: 2,
    desktop: 3,
    widescreen: 4
  };

  const newGridColumns = {
    ...currentGridColumns,
    [device]: parseInt(value, 10)
  };

  console.log(`Updating ${device} columns to:`, value, 'Full gridColumns:', newGridColumns);
  updateContent('gridColumns', newGridColumns);
};

  // Debug current grid columns
  React.useEffect(() => {
    console.log('Current content.gridColumns:', content?.gridColumns);
    console.log('Current content.displayType:', content?.displayType);
  }, [content?.gridColumns, content?.displayType]);

  return (
    <div>
      <h3 className="font-bold text-lg mb-4">Gallery Section</h3>

      {/* Gallery Settings */}
      <div className="mb-6 p-4 bg-gray-50 rounded">
        
        {/* Section Title Settings */}
        <div className="mb-6 p-4 bg-white rounded border">
          <h4 className="font-medium mb-4">Section Title</h4>
          
          <div className="grid grid-cols-1 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium mb-1">Title</label>
              <input
                type="text"
                value={content?.title || ''}
                onChange={(e) => updateGallerySetting('title', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="Gallery Title"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-1">Subtitle</label>
              <input
                type="text"
                value={content?.subtitle || ''}
                onChange={(e) => updateGallerySetting('subtitle', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="Gallery Subtitle"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium mb-1">Title Alignment</label>
              <select
                value={content?.titleAlignment || 'center'}
                onChange={(e) => updateGallerySetting('titleAlignment', e.target.value)}
                className="w-full p-2 border rounded"
              >
                <option value="left">Left</option>
                <option value="center">Center</option>
                <option value="right">Right</option>
              </select>
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-1">Title Font Size</label>
              <input
                type="text"
                value={content?.titleFontSize || '2rem'}
                onChange={(e) => updateGallerySetting('titleFontSize', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="e.g., 2rem, 24px"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-1">Title Color</label>
              <input
                type="color"
                value={content?.titleColor || '#333333'}
                onChange={(e) => updateGallerySetting('titleColor', e.target.value)}
                className="w-full p-1 border rounded h-10"
              />
            </div>
          </div>
        </div>





{/* Advanced Animation Settings */}
<div className="mb-6 p-4 bg-white rounded border">
  <h4 className="font-medium mb-4">Animation & Interaction</h4>
  
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
    <div>
      <label className="block text-sm font-medium mb-1">Load Animation</label>
      <select
        value={content?.loadAnimation || 'none'}
        onChange={(e) => updateGallerySetting('loadAnimation', e.target.value)}
        className="w-full p-2 border rounded"
      >
        <option value="none">None</option>
        <option value="fadeIn">Fade In</option>
        <option value="slideUp">Slide Up</option>
        <option value="zoomIn">Zoom In</option>
        <option value="staggered">Staggered</option>
      </select>
    </div>
    
    <div>
      <label className="block text-sm font-medium mb-1">Animation Duration</label>
      <input
        type="number"
        value={content?.animationDuration || 600}
        onChange={(e) => updateGallerySetting('animationDuration', parseInt(e.target.value))}
        className="w-full p-2 border rounded"
        min="100"
        max="2000"
        step="100"
      />
    </div>
  </div>
  
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
    <div>
      <label className="block text-sm font-medium mb-1">Stagger Delay</label>
      <input
        type="number"
        value={content?.staggerDelay || 100}
        onChange={(e) => updateGallerySetting('staggerDelay', parseInt(e.target.value))}
        className="w-full p-2 border rounded"
        min="50"
        max="500"
        step="50"
        disabled={content?.loadAnimation !== 'staggered'}
      />
    </div>
    
    <div>
      <label className="block text-sm font-medium mb-1">Transition Timing</label>
      <select
        value={content?.transitionTiming || 'ease'}
        onChange={(e) => updateGallerySetting('transitionTiming', e.target.value)}
        className="w-full p-2 border rounded"
      >
        <option value="ease">Ease</option>
        <option value="ease-in">Ease In</option>
        <option value="ease-out">Ease Out</option>
        <option value="ease-in-out">Ease In Out</option>
        <option value="linear">Linear</option>
        <option value="cubic-bezier(0.4, 0, 0.2, 1)">Custom</option>
      </select>
    </div>
  </div>
  
  <div className="mb-4">
    <label className="flex items-center">
      <input
        type="checkbox"
        checked={content?.parallaxEffect || false}
        onChange={(e) => updateGallerySetting('parallaxEffect', e.target.checked)}
        className="mr-2"
      />
      Enable Parallax Effect
    </label>
  </div>
  
  {content?.parallaxEffect && (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div>
        <label className="block text-sm font-medium mb-1">Parallax Speed</label>
        <input
          type="range"
          value={content?.parallaxSpeed || 0.5}
          onChange={(e) => updateGallerySetting('parallaxSpeed', parseFloat(e.target.value))}
          className="w-full"
          min="0.1"
          max="2"
          step="0.1"
        />
        <span className="text-sm text-gray-500">{content?.parallaxSpeed || 0.5}x</span>
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-1">Parallax Direction</label>
        <select
          value={content?.parallaxDirection || 'up'}
          onChange={(e) => updateGallerySetting('parallaxDirection', e.target.value)}
          className="w-full p-2 border rounded"
        >
          <option value="up">Up</option>
          <option value="down">Down</option>
          <option value="left">Left</option>
          <option value="right">Right</option>
        </select>
      </div>
    </div>
  )}
</div>

{/* Performance & Loading Settings */}
<div className="mb-6 p-4 bg-white rounded border">
  <h4 className="font-medium mb-4">Performance & Loading</h4>
  
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
    <div>
      <label className="flex items-center">
        <input
          type="checkbox"
          checked={content?.progressiveLoading || false}
          onChange={(e) => updateGallerySetting('progressiveLoading', e.target.checked)}
          className="mr-2"
        />
        Progressive Loading
      </label>
    </div>
    
    <div>
      <label className="block text-sm font-medium mb-1">Items Per Load</label>
      <input
        type="number"
        value={content?.itemsPerLoad || 6}
        onChange={(e) => updateGallerySetting('itemsPerLoad', parseInt(e.target.value))}
        className="w-full p-2 border rounded"
        min="3"
        max="20"
        disabled={!content?.progressiveLoading}
      />
    </div>
  </div>
  
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
    <div>
      <label className="block text-sm font-medium mb-1">Image Quality</label>
      <select
        value={content?.imageQuality || 'high'}
        onChange={(e) => updateGallerySetting('imageQuality', e.target.value)}
        className="w-full p-2 border rounded"
      >
        <option value="low">Low (Fast)</option>
        <option value="medium">Medium</option>
        <option value="high">High (Slow)</option>
        <option value="auto">Auto</option>
      </select>
    </div>
    
    <div>
      <label className="block text-sm font-medium mb-1">Preload Strategy</label>
      <select
        value={content?.preloadStrategy || 'metadata'}
        onChange={(e) => updateGallerySetting('preloadStrategy', e.target.value)}
        className="w-full p-2 border rounded"
      >
        <option value="none">None</option>
        <option value="metadata">Metadata</option>
        <option value="auto">Auto</option>
      </select>
    </div>
  </div>
  
  <div className="mb-4">
  <label className="flex items-center">
    <input
      type="checkbox"
      checked={content?.enableImageOptimization !== false}
      onChange={(e) => updateGallerySetting('enableImageOptimization', e.target.checked)}
      className="mr-2"
    />
    Enable Image Optimization
  </label>
</div>
</div>
    {/* Loading Animation Customization */}
<div className="mb-6 p-4 bg-white rounded border">
  <h4 className="font-medium mb-4">Loading Animation Customization</h4>
  
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
    <div>
      <label className="block text-sm font-medium mb-1">Loading Animation Type</label>
      <select
        value={content?.loadingAnimationType || 'default'}
        onChange={(e) => updateGallerySetting('loadingAnimationType', e.target.value)}
        className="w-full p-2 border rounded"
      >
        <option value="default">Default Spinner</option>
        <option value="custom">Custom Image/GIF</option>
        <option value="skeleton">Skeleton Loading</option>
        <option value="pulse">Pulse Effect</option>
      </select>
    </div>
    
    <div>
      <label className="block text-sm font-medium mb-1">Animation Speed</label>
      <select
        value={content?.loadingAnimationSpeed || 'normal'}
        onChange={(e) => updateGallerySetting('loadingAnimationSpeed', e.target.value)}
        className="w-full p-2 border rounded"
      >
        <option value="slow">Slow</option>
        <option value="normal">Normal</option>
        <option value="fast">Fast</option>
      </select>
    </div>
  </div>

  {/* Custom Loading Image/GIF Upload */}
  {content?.loadingAnimationType === 'custom' && (
    <div className="border-t pt-4">
      <h5 className="font-medium mb-3">Custom Loading Animation</h5>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Loading Image/GIF URL</label>
        <input
          type="text"
          value={content?.customLoadingImage || ''}
          onChange={(e) => updateGallerySetting('customLoadingImage', e.target.value)}
          className="w-full p-2 border rounded mb-2"
          placeholder="Enter image/GIF URL or upload below"
        />
        <ImageUploader
          onImageUpload={(path) => updateGallerySetting('customLoadingImage', path)}
          pageSlug={pageSlug}
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium mb-1">Loading Image Size</label>
          <input
            type="text"
            value={content?.loadingImageSize || '48px'}
            onChange={(e) => updateGallerySetting('loadingImageSize', e.target.value)}
            className="w-full p-2 border rounded"
            placeholder="e.g., 48px, 3rem"
          />
        </div>
        
        <div>
  <label className="block text-sm font-medium mb-1">Background Color</label>
  <div className="flex items-center gap-2">
    <input
      type="color"
      value={content?.loadingBackgroundColor || '#ffffff'}
      onChange={(e) => updateGallerySetting('loadingBackgroundColor', e.target.value)}
      className="w-12 h-10 border rounded cursor-pointer"
    />
    <input
      type="text"
      value={content?.loadingBackgroundColor || '#ffffff'}
      onChange={(e) => updateGallerySetting('loadingBackgroundColor', e.target.value)}
      className="flex-1 p-2 border rounded"
      placeholder="#ffffff"
    />
  </div>
</div>
<br></br>
<div>
  <label className="block text-sm font-medium mb-1">Loading Background Opacity</label>
  <input
    type="range"
    value={parseFloat(content?.loadingBackgroundOpacity ?? 0.9)}
    onChange={(e) => updateGallerySetting('loadingBackgroundOpacity', parseFloat(e.target.value))}
    className="w-full"
    min="0"
    max="1"
    step="0.1"
  />
  <span className="text-sm text-gray-500">
    {Math.round((content?.loadingBackgroundOpacity ?? 0.9) * 100)}%
  </span>
</div>
      </div>
       
      {/* Preview */}
{content?.customLoadingImage && (
  <div className="mt-4 p-4 border rounded bg-gray-50">
    <label className="block text-sm font-medium mb-2">Preview:</label>
    <div 
      className="inline-flex items-center justify-center p-4 rounded relative"
      style={{
        backgroundColor: content?.loadingBackgroundColor || '#ffffff',
        minWidth: '120px',
        minHeight: '80px'
      }}
    >
      <div
        style={{
          backgroundColor: content?.loadingBackgroundColor || '#ffffff',
          opacity: content?.loadingBackgroundOpacity || 0.9,
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          borderRadius: 'inherit'
        }}
      />
      <img
        src={content.customLoadingImage}
        alt="Loading animation preview"
        style={{
          width: content?.loadingImageSize || '48px',
          height: content?.loadingImageSize || '48px',
          maxWidth: content?.loadingImageSize || '48px',
          maxHeight: content?.loadingImageSize || '48px',
          objectFit: 'contain',
          position: 'relative',
          zIndex: 1
        }}
      />
    </div>
  </div>
)}
    </div>
    
  )}
  
  {/* Skeleton Loading Options */}
  {content?.loadingAnimationType === 'skeleton' && (
    <div className="border-t pt-4">
      <h5 className="font-medium mb-3">Skeleton Loading Options</h5>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium mb-1">Skeleton Color</label>
          <input
            type="color"
            value={content?.skeletonColor || '#f0f0f0'}
            onChange={(e) => updateGallerySetting('skeletonColor', e.target.value)}
            className="w-full p-1 border rounded h-10"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Highlight Color</label>
          <input
            type="color"
            value={content?.skeletonHighlightColor || '#e0e0e0'}
            onChange={(e) => updateGallerySetting('skeletonHighlightColor', e.target.value)}
            className="w-full p-1 border rounded h-10"
          />
        </div>
      </div>
    </div>
  )}

  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
    <div>
      <label className="block text-sm font-medium mb-1">Loading Text</label>
      <input
        type="text"
        value={content?.loadingText || 'Loading...'}
        onChange={(e) => updateGallerySetting('loadingText', e.target.value)}
        className="w-full p-2 border rounded"
        placeholder="Loading..."
      />
    </div>
    
    <div>
  <label className="flex items-center">
    <input
      type="checkbox"
      checked={content?.showLoadingText !== false}
      onChange={(e) => updateGallerySetting('showLoadingText', e.target.checked)}
      className="mr-2"
    />
    Show Loading Text
  </label>
</div>
  </div>
</div> 
  {/* Gallery Dimensions */}
  <div className="mb-6 p-4 bg-white rounded border">
  <h4 className="font-medium mb-4">Gallery Dimensions</h4>
  
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
    <div>
      <label className="block text-sm font-medium mb-1">Gallery Width</label>
      <input
        type="text"
        value={content?.galleryWidth || ''}
        onChange={(e) => updateGallerySetting('galleryWidth', e.target.value)}
        className="w-full p-2 border rounded"
        placeholder="e.g., 100%, 1200px, auto"
      />
    </div>
    
    <div>
      <label className="block text-sm font-medium mb-1">Gallery Height</label>
      <input
        type="text"
        value={content?.galleryHeight || ''}
        onChange={(e) => updateGallerySetting('galleryHeight', e.target.value)}
        className="w-full p-2 border rounded"
        placeholder="e.g., auto, 500px, 50vh"
      />
    </div>
  </div>
</div>  
{/* Layout Settings */}
<div className="mb-6 p-4 bg-white rounded border">
  <h4 className="font-medium mb-4">Layout Settings</h4>

  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
    <div>
      <label className="block text-sm font-medium mb-1">Display Type</label>
      <select
        value={content?.displayType || 'grid'}
        onChange={(e) => updateGallerySetting('displayType', e.target.value)}
        className="w-full p-2 border rounded"
      >
        <option value="grid">Grid</option>
        <option value="carousel">Carousel</option>
        <option value="flex">Flex</option>
        <option value="masonry">Masonry</option>
      </select>
    </div>

    <div>
      <label className="block text-sm font-medium mb-1">Gap Size</label>
      <input
        type="text"
        value={content?.gapSize || '1.5rem'}
        onChange={(e) => updateGallerySetting('gapSize', e.target.value)}
        className="w-full p-2 border rounded"
        placeholder="e.g., 1.5rem, 24px"
      />
    </div>
  </div>

  {/* Grid Layout Settings */}
  {content?.displayType === 'grid' && (
    <div className="border-t pt-4">
      <h5 className="font-medium mb-3">Grid Layout Settings</h5>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium mb-1">Mobile Columns</label>
          <select
            value={(content?.gridColumns?.mobile || 1).toString()}
            onChange={(e) => updateGridColumns('mobile', e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="1">1 Column</option>
            <option value="2">2 Columns</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Tablet Columns</label>
          <select
            value={(content?.gridColumns?.tablet || 2).toString()}
            onChange={(e) => updateGridColumns('tablet', e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="1">1 Column</option>
            <option value="2">2 Columns</option>
            <option value="3">3 Columns</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Desktop Columns</label>
          <select
            value={(content?.gridColumns?.desktop || 3).toString()}
            onChange={(e) => updateGridColumns('desktop', e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="2">2 Columns</option>
            <option value="3">3 Columns</option>
            <option value="4">4 Columns</option>
            <option value="5">5 Columns</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Widescreen Columns</label>
          <select
            value={(content?.gridColumns?.widescreen || 4).toString()}
            onChange={(e) => updateGridColumns('widescreen', e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="3">3 Columns</option>
            <option value="4">4 Columns</option>
            <option value="5">5 Columns</option>
            <option value="6">6 Columns</option>
          </select>
        </div>
      </div>
    </div>
  )}

  {/* Enhanced Layout Controls */}
{content?.displayType === 'flex' && (
  <div className="mb-6 p-4 bg-white rounded border">
    <h4 className="font-medium mb-4">Flex Layout Settings</h4>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div>
        <label className="block text-sm font-medium mb-1">Items Per Row (Desktop)</label>
        <select
          value={content?.flexItemsPerRow?.desktop || '3'}
          onChange={(e) => updateGallerySetting('flexItemsPerRow', {
            ...content?.flexItemsPerRow,
            desktop: parseInt(e.target.value)
          })}
          className="w-full p-2 border rounded"
        >
          <option value="1">1 Item</option>
          <option value="2">2 Items</option>
          <option value="3">3 Items</option>
          <option value="4">4 Items</option>
          <option value="5">5 Items</option>
          <option value="6">6 Items</option>
          <option value="auto">Auto Fit</option>
        </select>
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-1">Items Per Row (Mobile)</label>
        <select
          value={content?.flexItemsPerRow?.mobile || '1'}
          onChange={(e) => updateGallerySetting('flexItemsPerRow', {
            ...content?.flexItemsPerRow,
            mobile: parseInt(e.target.value)
          })}
          className="w-full p-2 border rounded"
        >
          <option value="1">1 Item</option>
          <option value="2">2 Items</option>
          <option value="3">3 Items</option>
        </select>
      </div>
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
      <div>
        <label className="block text-sm font-medium mb-1">Flex Direction</label>
        <select
          value={content?.flexDirection || 'row'}
          onChange={(e) => updateGallerySetting('flexDirection', e.target.value)}
          className="w-full p-2 border rounded"
        >
          <option value="row">Row</option>
          <option value="row-reverse">Row Reverse</option>
          <option value="column">Column</option>
          <option value="column-reverse">Column Reverse</option>
        </select>
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-1">Justify Content</label>
        <select
          value={content?.flexJustifyContent || 'flex-start'}
          onChange={(e) => updateGallerySetting('flexJustifyContent', e.target.value)}
          className="w-full p-2 border rounded"
        >
          <option value="flex-start">Start</option>
          <option value="flex-end">End</option>
          <option value="center">Center</option>
          <option value="space-between">Space Between</option>
          <option value="space-around">Space Around</option>
          <option value="space-evenly">Space Evenly</option>
        </select>
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-1">Align Items</label>
        <select
          value={content?.flexAlignItems || 'stretch'}
          onChange={(e) => updateGallerySetting('flexAlignItems', e.target.value)}
          className="w-full p-2 border rounded"
        >
          <option value="stretch">Stretch</option>
          <option value="flex-start">Start</option>
          <option value="flex-end">End</option>
          <option value="center">Center</option>
          <option value="baseline">Baseline</option>
        </select>
      </div>
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div>
        <label className="block text-sm font-medium mb-1">Item Flex Grow</label>
        <input
          type="number"
          value={content?.flexItemGrow || '0'}
          onChange={(e) => updateGallerySetting('flexItemGrow', e.target.value)}
          className="w-full p-2 border rounded"
          min="0"
          max="10"
          step="1"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-1">Item Flex Shrink</label>
        <input
          type="number"
          value={content?.flexItemShrink || '1'}
          onChange={(e) => updateGallerySetting('flexItemShrink', e.target.value)}
          className="w-full p-2 border rounded"
          min="0"
          max="10"
          step="1"
        />
      </div>
    </div>
    
    <div className="mb-4">
      <label className="block text-sm font-medium mb-1">Item Base Width</label>
      <input
        type="text"
        value={content?.flexItemBasis || 'auto'}
        onChange={(e) => updateGallerySetting('flexItemBasis', e.target.value)}
        className="w-full p-2 border rounded"
        placeholder="e.g., 300px, 33.33%, auto"
      />
    </div>
  </div>
)}

  {/* Carousel Layout Settings */}
  {content?.displayType === 'carousel' && (
    <div className="border-t pt-4">
      <h5 className="font-medium mb-3">Carousel Layout Settings</h5>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium mb-1">Visible Items (Desktop)</label>
          <select
            value={content?.carouselVisibleItems?.desktop || 3}
            onChange={(e) => updateGallerySetting('carouselVisibleItems', {
              ...content?.carouselVisibleItems,
              desktop: parseInt(e.target.value)
            })}
            className="w-full p-2 border rounded"
          >
            <option value={1}>1 Item</option>
            <option value={2}>2 Items</option>
            <option value={3}>3 Items</option>
            <option value={4}>4 Items</option>
            <option value={5}>5 Items</option>
            <option value={6}>6 Items</option>
          </select>
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Visible Items (Mobile)</label>
          <select
            value={content?.carouselVisibleItems?.mobile || 1}
            onChange={(e) => updateGallerySetting('carouselVisibleItems', {
              ...content?.carouselVisibleItems,
              mobile: parseInt(e.target.value)
            })}
            className="w-full p-2 border rounded"
          >
            <option value={1}>1 Item</option>
            <option value={2}>2 Items</option>
            <option value={3}>3 Items</option>
          </select>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium mb-1">Scroll Behavior</label>
          <select
            value={content?.carouselScrollBehavior || 'smooth'}
            onChange={(e) => updateGallerySetting('carouselScrollBehavior', e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="smooth">Smooth</option>
            <option value="auto">Auto</option>
            <option value="instant">Instant</option>
          </select>
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Scroll Amount (px)</label>
          <input
            type="number"
            value={content?.carouselScrollAmount || 300}
            onChange={(e) => updateGallerySetting('carouselScrollAmount', parseInt(e.target.value))}
            className="w-full p-2 border rounded"
            min="100"
            max="1000"
            step="50"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Item Width</label>
          <input
            type="text"
            value={content?.carouselItemWidth || '256px'}
            onChange={(e) => updateGallerySetting('carouselItemWidth', e.target.value)}
            className="w-full p-2 border rounded"
            placeholder="e.g., 256px, 20vw"
          />
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={content?.carouselCenterMode || false}
              onChange={(e) => updateGallerySetting('carouselCenterMode', e.target.checked)}
              className="mr-2"
            />
            Center Active Item
          </label>
        </div>
        
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={content?.carouselInfiniteLoop || false}
              onChange={(e) => updateGallerySetting('carouselInfiniteLoop', e.target.checked)}
              className="mr-2"
            />
            Infinite Loop
          </label>
        </div>
      </div>
    </div>
  )}

  {/* Masonry Layout Settings */}
  {content?.displayType === 'masonry' && (
    <div className="border-t pt-4">
      <h5 className="font-medium mb-3">Masonry Layout Settings</h5>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium mb-1">Columns (Desktop)</label>
          <select
            value={content?.masonryColumns?.desktop || 3}
            onChange={(e) => updateGallerySetting('masonryColumns', {
              ...content?.masonryColumns,
              desktop: parseInt(e.target.value)
            })}
            className="w-full p-2 border rounded"
          >
            <option value={2}>2 Columns</option>
            <option value={3}>3 Columns</option>
            <option value={4}>4 Columns</option>
            <option value={5}>5 Columns</option>
            <option value={6}>6 Columns</option>
          </select>
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Columns (Mobile)</label>
          <select
            value={content?.masonryColumns?.mobile || 1}
            onChange={(e) => updateGallerySetting('masonryColumns', {
              ...content?.masonryColumns,
              mobile: parseInt(e.target.value)
            })}
            className="w-full p-2 border rounded"
          >
            <option value={1}>1 Column</option>
            <option value={2}>2 Columns</option>
          </select>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium mb-1">Column Fill</label>
          <select
            value={content?.masonryColumnFill || 'balance'}
            onChange={(e) => updateGallerySetting('masonryColumnFill', e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="balance">Balance</option>
            <option value="auto">Auto</option>
          </select>
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Break Inside</label>
          <select
            value={content?.masonryBreakInside || 'avoid'}
            onChange={(e) => updateGallerySetting('masonryBreakInside', e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="avoid">Avoid</option>
            <option value="auto">Auto</option>
            <option value="avoid-page">Avoid Page</option>
          </select>
        </div>
      </div>
    </div>
  )}
  {/* Enhanced Carousel Settings */}
{content?.displayType === 'carousel' && (
  <div className="mb-6 p-4 bg-white rounded border">
    <h4 className="font-medium mb-4">Enhanced Carousel Settings</h4>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div>
        <label className="block text-sm font-medium mb-1">Visible Items (Desktop)</label>
        <select
          value={content?.carouselVisibleItems?.desktop || '3'}
          onChange={(e) => updateGallerySetting('carouselVisibleItems', {
            ...content?.carouselVisibleItems,
            desktop: parseInt(e.target.value)
          })}
          className="w-full p-2 border rounded"
        >
          <option value="1">1 Item</option>
          <option value="2">2 Items</option>
          <option value="3">3 Items</option>
          <option value="4">4 Items</option>
          <option value="5">5 Items</option>
          <option value="6">6 Items</option>
        </select>
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-1">Visible Items (Mobile)</label>
        <select
          value={content?.carouselVisibleItems?.mobile || '1'}
          onChange={(e) => updateGallerySetting('carouselVisibleItems', {
            ...content?.carouselVisibleItems,
            mobile: parseInt(e.target.value)
          })}
          className="w-full p-2 border rounded"
        >
          <option value="1">1 Item</option>
          <option value="2">2 Items</option>
          <option value="3">3 Items</option>
        </select>
      </div>
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
      <div>
        <label className="block text-sm font-medium mb-1">Scroll Behavior</label>
        <select
          value={content?.carouselScrollBehavior || 'smooth'}
          onChange={(e) => updateGallerySetting('carouselScrollBehavior', e.target.value)}
          className="w-full p-2 border rounded"
        >
          <option value="smooth">Smooth</option>
          <option value="auto">Auto</option>
          <option value="instant">Instant</option>
        </select>
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-1">Scroll Amount</label>
        <input
          type="number"
          value={content?.carouselScrollAmount || 300}
          onChange={(e) => updateGallerySetting('carouselScrollAmount', parseInt(e.target.value))}
          className="w-full p-2 border rounded"
          min="100"
          max="1000"
          step="50"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-1">Item Width</label>
        <input
          type="text"
          value={content?.carouselItemWidth || '256px'}
          onChange={(e) => updateGallerySetting('carouselItemWidth', e.target.value)}
          className="w-full p-2 border rounded"
          placeholder="e.g., 256px, 20vw"
        />
      </div>
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div>
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={content?.carouselCenterMode || false}
            onChange={(e) => updateGallerySetting('carouselCenterMode', e.target.checked)}
            className="mr-2"
          />
          Center Active Item
        </label>
      </div>
      
      <div>
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={content?.carouselInfiniteLoop || false}
            onChange={(e) => updateGallerySetting('carouselInfiniteLoop', e.target.checked)}
            className="mr-2"
          />
          Infinite Loop
        </label>
      </div>
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div>
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={content?.carouselShowDots || false}
            onChange={(e) => updateGallerySetting('carouselShowDots', e.target.checked)}
            className="mr-2"
          />
          Show Dots Navigation
        </label>
      </div>
      
      <div>
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={content?.carouselShowCounter || false}
            onChange={(e) => updateGallerySetting('carouselShowCounter', e.target.checked)}
            className="mr-2"
          />
          Show Item Counter
        </label>
      </div>
    </div>
    
    {/* Scrollbar Styling */}
    <div className="border-t pt-4">
      <h5 className="font-medium mb-3">Scrollbar Styling</h5>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={content?.customScrollbar || false}
              onChange={(e) => updateGallerySetting('customScrollbar', e.target.checked)}
              className="mr-2"
            />
            Custom Scrollbar
          </label>
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Scrollbar Height</label>
          <input
            type="text"
            value={content?.scrollbarHeight || '8px'}
            onChange={(e) => updateGallerySetting('scrollbarHeight', e.target.value)}
            className="w-full p-2 border rounded"
            disabled={!content?.customScrollbar}
          />
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium mb-1">Track Color</label>
          <input
            type="color"
            value={content?.scrollbarTrackColor || '#f1f1f1'}
            onChange={(e) => updateGallerySetting('scrollbarTrackColor', e.target.value)}
            className="w-full p-1 border rounded h-10"
            disabled={!content?.customScrollbar}
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Thumb Color</label>
          <input
            type="color"
            value={content?.scrollbarThumbColor || '#c1c1c1'}
            onChange={(e) => updateGallerySetting('scrollbarThumbColor', e.target.value)}
            className="w-full p-1 border rounded h-10"
            disabled={!content?.customScrollbar}
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Thumb Border Radius</label>
          <input
            type="text"
            value={content?.scrollbarThumbRadius || '10px'}
            onChange={(e) => updateGallerySetting('scrollbarThumbRadius', e.target.value)}
            className="w-full p-2 border rounded"
            disabled={!content?.customScrollbar}
          />
        </div>
      </div>
    </div>
  </div>
)}

{/* Masonry Advanced Settings */}
{content?.displayType === 'masonry' && (
  <div className="mb-6 p-4 bg-white rounded border">
    <h4 className="font-medium mb-4">Masonry Layout Settings</h4>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div>
        <label className="block text-sm font-medium mb-1">Columns (Desktop)</label>
        <select
          value={content?.masonryColumns?.desktop || '3'}
          onChange={(e) => updateGallerySetting('masonryColumns', {
            ...content?.masonryColumns,
            desktop: parseInt(e.target.value)
          })}
          className="w-full p-2 border rounded"
        >
          <option value="2">2 Columns</option>
          <option value="3">3 Columns</option>
          <option value="4">4 Columns</option>
          <option value="5">5 Columns</option>
          <option value="6">6 Columns</option>
        </select>
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-1">Columns (Mobile)</label>
        <select
          value={content?.masonryColumns?.mobile || '1'}
          onChange={(e) => updateGallerySetting('masonryColumns', {
            ...content?.masonryColumns,
            mobile: parseInt(e.target.value)
          })}
          className="w-full p-2 border rounded"
        >
          <option value="1">1 Column</option>
          <option value="2">2 Columns</option>
        </select>
      </div>
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div>
        <label className="block text-sm font-medium mb-1">Column Fill</label>
        <select
          value={content?.masonryColumnFill || 'balance'}
          onChange={(e) => updateGallerySetting('masonryColumnFill', e.target.value)}
          className="w-full p-2 border rounded"
        >
          <option value="balance">Balance</option>
          <option value="auto">Auto</option>
        </select>
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-1">Break Inside</label>
        <select
          value={content?.masonryBreakInside || 'avoid'}
          onChange={(e) => updateGallerySetting('masonryBreakInside', e.target.value)}
          className="w-full p-2 border rounded"
        >
          <option value="avoid">Avoid</option>
          <option value="auto">Auto</option>
          <option value="avoid-page">Avoid Page</option>
        </select>
      </div>
    </div>
  </div>
)}

</div>

{/* Enhanced Carousel Controls (separate section after Layout Settings) */}
{content?.displayType === 'carousel' && (
  <div className="mb-6 p-4 bg-white rounded border">
    <h4 className="font-medium mb-4">Carousel Controls & Navigation</h4>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div>
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={content?.enableScrolling !== false}
            onChange={(e) => updateGallerySetting('enableScrolling', e.target.checked)}
            className="mr-2"
          />
          Enable Horizontal Scrolling
        </label>
      </div>

      <div>
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={content?.showNavigation !== false}
            onChange={(e) => updateGallerySetting('showNavigation', e.target.checked)}
            className="mr-2"
          />
          Show Navigation Buttons
        </label>
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div>
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={content?.carouselShowDots || false}
            onChange={(e) => updateGallerySetting('carouselShowDots', e.target.checked)}
            className="mr-2"
          />
          Show Dots Navigation
        </label>
      </div>
      
      <div>
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={content?.carouselShowCounter || false}
            onChange={(e) => updateGallerySetting('carouselShowCounter', e.target.checked)}
            className="mr-2"
          />
          Show Item Counter
        </label>
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div>
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={content?.autoplay || false}
            onChange={(e) => updateGallerySetting('autoplay', e.target.checked)}
            className="mr-2"
          />
          Enable Autoplay
        </label>
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">Autoplay Speed (ms)</label>
        <input
          type="number"
          value={content?.autoplaySpeed || 3000}
          onChange={(e) => updateGallerySetting('autoplaySpeed', parseInt(e.target.value))}
          className="w-full p-2 border rounded"
          min="1000"
          step="500"
          disabled={!content?.autoplay}
        />
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <div>
        <label className="block text-sm font-medium mb-1">Navigation Color</label>
        <input
          type="color"
          className="w-full p-1 border rounded h-10"
          value={content?.navigationColor || '#e5e7eb'}
          onChange={(e) => updateGallerySetting('navigationColor', e.target.value)}
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">Navigation Hover Color</label>
        <input
          type="color"
          className="w-full p-1 border rounded h-10"
          value={content?.navigationHoverColor || '#d1d5db'}
          onChange={(e) => updateGallerySetting('navigationHoverColor', e.target.value)}
        />
      </div>
    </div>
    
    {/* Custom Scrollbar Settings */}
    <div className="border-t pt-4">
      <h5 className="font-medium mb-3">Custom Scrollbar</h5>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={content?.customScrollbar || false}
              onChange={(e) => updateGallerySetting('customScrollbar', e.target.checked)}
              className="mr-2"
            />
            Enable Custom Scrollbar
          </label>
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Scrollbar Height</label>
          <input
            type="text"
            value={content?.scrollbarHeight || '8px'}
            onChange={(e) => updateGallerySetting('scrollbarHeight', e.target.value)}
            className="w-full p-2 border rounded"
            disabled={!content?.customScrollbar}
            placeholder="e.g., 8px, 12px"
          />
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium mb-1">Track Color</label>
          <input
            type="color"
            value={content?.scrollbarTrackColor || '#f1f1f1'}
            onChange={(e) => updateGallerySetting('scrollbarTrackColor', e.target.value)}
            className="w-full p-1 border rounded h-10"
            disabled={!content?.customScrollbar}
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Thumb Color</label>
          <input
            type="color"
            value={content?.scrollbarThumbColor || '#c1c1c1'}
            onChange={(e) => updateGallerySetting('scrollbarThumbColor', e.target.value)}
            className="w-full p-1 border rounded h-10"
            disabled={!content?.customScrollbar}
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Thumb Border Radius</label>
          <input
            type="text"
            value={content?.scrollbarThumbRadius || '10px'}
            onChange={(e) => updateGallerySetting('scrollbarThumbRadius', e.target.value)}
            className="w-full p-2 border rounded"
            disabled={!content?.customScrollbar}
            placeholder="e.g., 10px, 50%"
          />
        </div>
      </div>
    </div>
  </div>
)}
        {/* Container Styling */}
        <div className="mb-6 p-4 bg-white rounded border">
          <h4 className="font-medium mb-4">Container Styling</h4>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium mb-1">Background Color</label>
              <input
                type="color"
                className="w-full p-1 border rounded h-10"
                value={content?.backgroundColor || '#ffffff'}
                onChange={(e) => updateGallerySetting('backgroundColor', e.target.value)}
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Border Color</label>
              <input
                type="color"
                className="w-full p-1 border rounded h-10"
                value={content?.borderColor || '#e5e7eb'}
                onChange={(e) => updateGallerySetting('borderColor', e.target.value)}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium mb-1">Border Width</label>
              <select
                className="w-full p-2 border rounded"
                value={content?.borderWidth || '0'}
                onChange={(e) => updateGallerySetting('borderWidth', e.target.value)}
              >
                <option value="0">None</option>
                <option value="1">1px</option>
                <option value="2">2px</option>
                <option value="4">4px</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Border Radius</label>
              <select
                className="w-full p-2 border rounded"
                value={content?.borderRadius || 'rounded'}
                onChange={(e) => updateGallerySetting('borderRadius', e.target.value)}
              >
                <option value="none">None</option>
                <option value="rounded-sm">Small</option>
                <option value="rounded">Medium</option>
                <option value="rounded-lg">Large</option>
                <option value="rounded-xl">Extra Large</option>
                <option value="rounded-full">Full</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Box Shadow</label>
              <select
                className="w-full p-2 border rounded"
                value={content?.boxShadow || 'none'}
                onChange={(e) => updateGallerySetting('boxShadow', e.target.value)}
              >
                <option value="none">None</option>
                <option value="small">Small</option>
                <option value="medium">Medium</option>
                <option value="large">Large</option>
                <option value="xl">Extra Large</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium mb-1">Container Padding</label>
              <input
                type="text"
                value={content?.containerPadding || ''}
                onChange={(e) => updateGallerySetting('containerPadding', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="e.g., 1rem, 16px"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Max Width</label>
              <input
                type="text"
                value={content?.maxWidth || ''}
                onChange={(e) => updateGallerySetting('maxWidth', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="e.g., 1200px, 100%"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Min Height</label>
              <input
                type="text"
                value={content?.minHeight || ''}
                onChange={(e) => updateGallerySetting('minHeight', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="e.g., 300px, 20rem"
              />
            </div>
          </div>
        </div>

        {/* Item Styling */}
        <div className="mb-6 p-4 bg-white rounded border">
          <h4 className="font-medium mb-4">Item Styling</h4>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium mb-1">Default Image Height</label>
              <input
                type="text"
                className="w-full p-2 border rounded"
                placeholder="e.g., 64, auto, 200px"
                value={content?.imageHeight || '64'}
                onChange={(e) => updateGallerySetting('imageHeight', e.target.value)}
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Image Object Fit</label>
              <select
                className="w-full p-2 border rounded"
                value={content?.imageObjectFit || 'cover'}
                onChange={(e) => updateGallerySetting('imageObjectFit', e.target.value)}
              >
                <option value="cover">Cover</option>
                <option value="contain">Contain</option>
                <option value="fill">Fill</option>
                <option value="scale-down">Scale Down</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium mb-1">Item Background Color</label>
              <input
                type="color"
                className="w-full p-1 border rounded h-10"
                value={content?.itemBackgroundColor || '#ffffff'}
                onChange={(e) => updateGallerySetting('itemBackgroundColor', e.target.value)}
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Item Shadow</label>
              <select
                className="w-full p-2 border rounded"
                value={content?.itemShadow || 'none'}
                onChange={(e) => updateGallerySetting('itemShadow', e.target.value)}
              >
                <option value="none">None</option>
                <option value="small">Small</option>
                <option value="medium">Medium</option>
                <option value="large">Large</option>
              </select>
            </div>
          </div>

          <div className="mb-4">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={content?.lazyLoading !== false}
                onChange={(e) => updateGallerySetting('lazyLoading', e.target.checked)}
                className="mr-2"
              />
              Enable Lazy Loading
            </label>
          </div>
        </div>

        {/* Caption Settings */}
        <div className="mb-6 p-4 bg-white rounded border">
          <h4 className="font-medium mb-4">Caption Settings</h4>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium mb-1">Caption Position</label>
              <select
                className="w-full p-2 border rounded"
                value={content?.captionPosition || 'bottom'}
                onChange={(e) => updateGallerySetting('captionPosition', e.target.value)}
              >
                <option value="none">Hidden</option>
                <option value="bottom">Bottom</option>
                <option value="top">Top</option>
                <option value="overlay">Overlay</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Caption Style</label>
              <select
                className="w-full p-2 border rounded"
                value={content?.captionStyle || 'normal'}
                onChange={(e) => updateGallerySetting('captionStyle', e.target.value)}
              >
                <option value="normal">Normal</option>
                <option value="bold">Bold</option>
                <option value="italic">Italic</option>
                <option value="underline">Underline</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium mb-1">Caption Font Size</label>
              <input
                type="text"
                value={content?.captionFontSize || '14px'}
                onChange={(e) => updateGallerySetting('captionFontSize', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="e.g., 14px, 0.875rem"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Caption Color</label>
              <input
                type="color"
                className="w-full p-1 border rounded h-10"
                value={content?.captionColor || '#666666'}
                onChange={(e) => updateGallerySetting('captionColor', e.target.value)}
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Caption Background (Overlay)</label>
              <input
                type="color"
                className="w-full p-1 border rounded h-10"
                value={content?.captionBackgroundColor || '#000000'}
                onChange={(e) => updateGallerySetting('captionBackgroundColor', e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Carousel Settings */}
        {content?.displayType === 'carousel' && (
          <div className="mb-6 p-4 bg-white rounded border">
            <h4 className="font-medium mb-4">Carousel Settings</h4>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={content?.enableScrolling !== false}
                    onChange={(e) => updateGallerySetting('enableScrolling', e.target.checked)}
                    className="mr-2"
                  />
                  Enable Horizontal Scrolling
                </label>
              </div>

              <div>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={content?.showNavigation !== false}
                    onChange={(e) => updateGallerySetting('showNavigation', e.target.checked)}
                    className="mr-2"
                  />
                  Show Navigation Buttons
                </label>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={content?.autoplay || false}
                    onChange={(e) => updateGallerySetting('autoplay', e.target.checked)}
                    className="mr-2"
                  />
                  Enable Autoplay
                </label>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Autoplay Speed (ms)</label>
                <input
                  type="number"
                  value={content?.autoplaySpeed || 3000}
                  onChange={(e) => updateGallerySetting('autoplaySpeed', parseInt(e.target.value))}
                  className="w-full p-2 border rounded"
                  min="1000"
                  step="500"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium mb-1">Navigation Color</label>
                <input
                  type="color"
                  className="w-full p-1 border rounded h-10"
                  value={content?.navigationColor || '#e5e7eb'}
                  onChange={(e) => updateGallerySetting('navigationColor', e.target.value)}
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Navigation Hover Color</label>
                <input
                  type="color"
                  className="w-full p-1 border rounded h-10"
                  value={content?.navigationHoverColor || '#d1d5db'}
                  onChange={(e) => updateGallerySetting('navigationHoverColor', e.target.value)}
                />
              </div>
            </div>
          </div>
        )}

        {/* Modal Settings */}
        <div className="mb-6 p-4 bg-white rounded border">
          <h4 className="font-medium mb-4">Modal Settings</h4>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium mb-1">Modal Background Color</label>
              <input
                type="color"
                className="w-full p-1 border rounded h-10"
                value={content?.modalBackgroundColor || '#000000'}
                onChange={(e) => updateGallerySetting('modalBackgroundColor', e.target.value)}
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Modal Content Background</label>
              <input
                type="color"
                className="w-full p-1 border rounded h-10"
                value={content?.modalContentBackground || '#ffffff'}
                onChange={(e) => updateGallerySetting('modalContentBackground', e.target.value)}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium mb-1">Modal Max Width</label>
              <input
                type="text"
                value={content?.modalMaxWidth || '90vw'}
                onChange={(e) => updateGallerySetting('modalMaxWidth', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="e.g., 90vw, 800px"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Modal Max Height</label>
              <input
                type="text"
                value={content?.modalMaxHeight || '90vh'}
                onChange={(e) => updateGallerySetting('modalMaxHeight', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="e.g., 90vh, 600px"
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={content?.modalBlur || false}
                onChange={(e) => updateGallerySetting('modalBlur', e.target.checked)}
                className="mr-2"
              />
              Enable Background Blur
            </label>
          </div>
        </div>
      </div>

      {/* Individual Images */}
      <div className="mb-4">
        <h4 className="font-medium mb-3">Gallery Items</h4>
        {(content?.images || []).map((image, index) => (
          <div key={index} className="mb-4 p-3 border rounded">
            <div className="flex justify-between items-center mb-2">
              <h4 className="font-medium">Item {index + 1}</h4>
              <button
                type="button"
                className="text-red-500 hover:text-red-700"
                onClick={() => removeImage(index)}
              >
                Remove
              </button>
            </div>

            {/* Media Type Selection */}
            <div className="mb-2">
              <label className="block text-sm mb-1">Media Type</label>
              <select
                className="w-full p-2 border rounded"
                value={image.type || 'image'}
                onChange={(e) => updateImage(index, 'type', e.target.value)}
              >
                <option value="image">Image</option>
                <option value="video">Video</option>
              </select>
            </div>

            {/* Media Upload */}
            <div className="mb-2">
              <label className="block text-sm mb-1">
                {image.type === 'video' ? 'Video' : 'Image'}
              </label>
              {image.type === 'video' ? (
                <>
                  <input
                    type="text"
                    className="w-full p-2 border rounded mb-2"
                    placeholder="Video URL or upload below"
                    value={image.url || ''}
                    onChange={(e) => updateImage(index, 'url', e.target.value)}
                  />
                  <VideoUploader
                    onVideoUpload={(path) => updateImage(index, 'url', path)}
                    pageSlug={pageSlug}
                  />
                </>
              ) : (
                <>
                  <input
                    type="text"
                    className="w-full p-2 border rounded"
                    value={image.url || ''}
                    onChange={(e) => updateImage(index, 'url', e.target.value)}
                  />
                  <ImageUploader
                    onImageUpload={(path) => updateImage(index, 'url', path)}
                    pageSlug={pageSlug}
                  />
                </>
              )}
            </div>

            {/* Basic Info */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-2">
              <div>
                <label className="block text-sm mb-1">Alt Text</label>
                <input
                  type="text"
                  className="w-full p-2 border rounded"
                  value={image.alt || ''}
                  onChange={(e) => updateImage(index, 'alt', e.target.value)}
                />
              </div>

              <div>
                <label className="block text-sm mb-1">Caption</label>
                <input
                  type="text"
                  className="w-full p-2 border rounded"
                  value={image.caption || ''}
                  onChange={(e) => updateImage(index, 'caption', e.target.value)}
                />
              </div>
            </div>

            {/* Custom Dimensions */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-2">
              <div>
                <label className="block text-sm mb-1">Custom Width</label>
                <input
                  type="text"
                  className="w-full p-2 border rounded"
                  placeholder="e.g., 200px, 50%, auto"
                  value={image.width || ''}
                  onChange={(e) => updateImage(index, 'width', e.target.value)}
                />
              </div>
              
              <div>
                <label className="block text-sm mb-1">Custom Height</label>
                <input
                  type="text"
                  className="w-full p-2 border rounded"
                  placeholder="e.g., 150px, auto"
                  value={image.height || ''}
                  onChange={(e) => updateImage(index, 'height', e.target.value)}
                />
              </div>

              <div>
                <label className="block text-sm mb-1">Object Fit</label>
                <select
                  className="w-full p-2 border rounded"
                  value={image.objectFit || 'cover'}
                  onChange={(e) => updateImage(index, 'objectFit', e.target.value)}
                >
                  <option value="cover">Cover</option>
                  <option value="contain">Contain</option>
                  <option value="fill">Fill</option>
                  <option value="scale-down">Scale Down</option>
                </select>
              </div>
            </div>

            {/* Individual Item Settings */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-2">
              <div>
                <label className="block text-sm mb-1">Hover Effect</label>
                <select
                  className="w-full p-2 border rounded"
                  value={image.hoverEffect || 'zoom'}
                  onChange={(e) => updateImage(index, 'hoverEffect', e.target.value)}
                >
                  <option value="none">None</option>
                  <option value="zoom">Zoom</option>
                  <option value="fade">Fade</option>
                  <option value="slide">Slide</option>
                  <option value="rotate">Rotate</option>
                </select>
              </div>

              <div>
                <label className="block text-sm mb-1">Click Action</label>
                <select
                  className="w-full p-2 border rounded"
                  value={image.onClickAction || 'modal'}
                  onChange={(e) => updateImage(index, 'onClickAction', e.target.value)}
                >
                  <option value="none">None</option>
                  <option value="modal">Open Modal</option>
                  <option value="link">Open Link</option>
                  <option value="download">Download</option>
                </select>
              </div>
            </div>

            {/* Link URL for click action */}
            {image.onClickAction === 'link' && (
              <div className="mb-2">
                <label className="block text-sm mb-1">Link URL</label>
                <input
                  type="text"
                  className="w-full p-2 border rounded"
                  value={image.linkUrl || ''}
                  onChange={(e) => updateImage(index, 'linkUrl', e.target.value)}
                  placeholder="https://example.com"
                />
              </div>
            )}

            {/* Checkboxes */}
            <div className="flex gap-4 mb-2">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={image.isActive !== false}
                  onChange={(e) => updateImage(index, 'isActive', e.target.checked)}
                  className="mr-2"
                />
                Active
              </label>

              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={image.clickable !== false}
                  onChange={(e) => updateImage(index, 'clickable', e.target.checked)}
                  className="mr-2"
                />
                Clickable
              </label>
            </div>

            {/* Preview */}
            {image.url && (
              <div className="mt-2 p-2 border rounded">
                {image.type === 'video' ? (
                  <video
                    src={image.url}
                    className="max-w-full h-auto max-h-32 mx-auto"
                    controls
                    style={{
                      width: image.width || 'auto',
                      height: image.height || 'auto',
                      objectFit: image.objectFit || 'cover'
                    }}
                  />
                ) : (
                  <img
                    src={image.url}
                    alt={image.alt || `Gallery image ${index + 1}`}
                    className="max-w-full h-auto max-h-32 mx-auto"
                    style={{
                      width: image.width || 'auto',
                      height: image.height || 'auto',
                      objectFit: image.objectFit || 'cover'
                    }}
                  />
                )}
              </div>
            )}
          </div>
        ))}

        <button
          type="button"
          className="w-full p-2 border border-dashed rounded text-blue-500 hover:bg-blue-50"
          onClick={addImage}
        >
          + Add Media Item
        </button>
      </div>
    </div>
  );
};

export default GalleryForm;



// // working simpel before saba edition
// // src/components/admin/page-management/section-forms/GalleryForm.js
// import React from 'react';
// import ImageUploader from '../ImageUploader';

// const GalleryForm = ({ content, updateContent, pageSlug }) => {
//   const addImage = () => {
//     const images = content?.images || [];
//     const newImages = [
//       ...images,
//       { url: '', alt: '', caption: '' }
//     ];
//     updateContent('images', newImages);
//   };
  
//   const updateImage = (index, field, value) => {
//     const images = [...(content?.images || [])];
//     if (!images[index]) return;
    
//     images[index] = {
//       ...images[index],
//       [field]: value
//     };
    
//     updateContent('images', images);
//   };
  
//   const removeImage = (index) => {
//     const images = [...(content?.images || [])];
//     images.splice(index, 1);
//     updateContent('images', images);
//   };
  
//   return (
//     <div>
//       <h3 className="font-bold text-lg mb-4">Gallery Section</h3>
      
//       <div className="mb-4">
//         {(content?.images || []).map((image, index) => (
//           <div key={index} className="mb-4 p-3 border rounded">
//             <div className="flex justify-between items-center mb-2">
//               <h4 className="font-medium">Image {index + 1}</h4>
//               <button
//                 type="button"
//                 className="text-red-500 hover:text-red-700"
//                 onClick={() => removeImage(index)}
//               >
//                 Remove
//               </button>
//             </div>
            
//             <div className="mb-2">
//               <label className="block text-sm mb-1">Image URL</label>
//               <input
//                 type="text"
//                 className="w-full p-2 border rounded"
//                 value={image.url || ''}
//                 onChange={(e) => updateImage(index, 'url', e.target.value)}
//               />
//               <ImageUploader 
//                 onImageUpload={(path) => updateImage(index, 'url', path)} 
//                 pageSlug={pageSlug} 
//               />
//             </div>
            
//             <div className="mb-2">
//               <label className="block text-sm mb-1">Alt Text</label>
//               <input
//                 type="text"
//                 className="w-full p-2 border rounded"
//                 value={image.alt || ''}
//                 onChange={(e) => updateImage(index, 'alt', e.target.value)}
//               />
//             </div>
            
//             <div className="mb-2">
//               <label className="block text-sm mb-1">Caption</label>
//               <input
//                 type="text"
//                 className="w-full p-2 border rounded"
//                 value={image.caption || ''}
//                 onChange={(e) => updateImage(index, 'caption', e.target.value)}
//               />
//             </div>

//             {image.url && (
//               <div className="mt-2 p-2 border rounded">
//                 <img 
//                   src={image.url} 
//                   alt={image.alt || `Gallery image ${index + 1}`}
//                   className="max-w-full h-auto max-h-32 mx-auto"
//                 />
//               </div>
//             )}
//           </div>
//         ))}
        
//         <button
//           type="button"
//           className="w-full p-2 border border-dashed rounded text-blue-500 hover:bg-blue-50"
//           onClick={addImage}
//         >
//           + Add Image
//         </button>
//       </div>
//     </div>
//   );
// };

// export default GalleryForm;

